import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { CustomPaginatorIntl } from '@app/shared/custom-paginator/custom-paginator.component';
import { Labels } from '@core/constants/labels';
import { Image } from '@core/models/image.model';
import { SlideService } from '@core/services/slide-service/slide-service.service';
import { environment } from '@environment/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-image-mosaic',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatPaginatorModule],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }],
  templateUrl: './image-mosaic.component.html',
  styleUrl: './image-mosaic.component.scss',
})
export class ImageMosaicComponent implements OnDestroy, OnChanges, OnInit {
  labels = Labels.PAGINATORS;
  count = 0;
  pageSize = 10;
  pageIndex = 0;

  hidePageSize = true;
  showFirstLastButtons = true;

  imageList: Image[] = [];
  thumbUrl = `${environment.slideManagerUrl}/slide/thumb`;
  selectedId = -1;
  @Output() selectedImage = new EventEmitter<Image>();

  subscriptions = new Subscription();

  constructor(private slideService: SlideService) {}

  handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    const currentFilterData = this.slideService.filterData;
    currentFilterData.page_size = this.pageSize;
    currentFilterData.page = this.pageIndex;
    this.slideService.updateFilters(currentFilterData);
    this.updateList();
  }

  ngOnInit() {
    this.updateList();
    const filterSubscription = this.slideService.filterUpdateEmitter.subscribe(
      () => {
        this.updateList();
      },
    );
    this.subscriptions.add(filterSubscription);
  }

  ngOnChanges() {
    this.updateList();
  }

  updateList() {
    const listSub = this.slideService
      .getImageListPython()
      .subscribe((l: any) => {
        this.imageList = l.results as Image[];
        this.count = l.count;
        this.pageSize = this.slideService.filterData.page_size;
        this.pageIndex = this.slideService.filterData.page;
      });
    this.subscriptions.add(listSub);
  }

  selectImage(imageSelected: Image) {
    this.selectedId = imageSelected.id;
    this.selectedImage.emit(imageSelected);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
